import React, { useId } from 'react';
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconEnergyBolt = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="apricot">
      <G clipPath="url(#clip0_4828_10319)">
        <Path d="M13.551 10.9375H17.116C17.5413 10.9375 17.9249 11.2131 18.0464 11.6248C18.2223 12.0398 18.1104 12.508 17.7907 12.8002L9.60548 20.2377C9.24418 20.5631 8.71566 20.5896 8.32942 20.2974C7.94286 20.0053 7.80218 19.474 7.9905 19.0191L10.4496 13.0625H6.85576C6.45834 13.0625 6.07667 12.7869 5.92675 12.3752C5.77682 11.9601 5.88999 11.492 6.21086 11.1998L14.3951 3.76289C14.7564 3.43624 15.2839 3.41137 15.6708 3.70299C16.0577 3.99472 16.1984 4.52497 16.0097 4.98118L13.551 10.9375Z" fill={`url(#gradient_${id})`}/>
      </G>
      <Defs>
        <ClipPath id="clip0_4828_10319">
          <Rect width="12.2778" height="17" fill="white" transform="translate(5.86133 3.5)"/>
        </ClipPath>
      </Defs>
    </IconWithGradient>);
};
